export default "__VITE_ASSET__t8xdJFXF__"